module.exports = __webpack_public_path__ + "static/media/landing2.b12ecb7e.png";